// models
import { MenuModel } from '@/models'

// constants
import { ROLES_USER } from './roles'

const allRoles = Object.keys(ROLES_USER).map((k): number => {
    return ROLES_USER[k]
})

let i = 0

export const menuHorizontalItems: MenuModel[] = [
    {
        id: i++,
        label: 'Inicio',
        icon: 'ri-dashboard-line',
        link: '/',
        name: 'Dashboard',
        roleUser: allRoles
    },
    {
        id: i++,
        label: 'Asistencia',
        icon: 'ri-profile-line',
        link: '/assistances',
        name: 'assistances',
        roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN]
    },
    {
        id: i++,
        label: 'Destajo',
        icon: 'ri-file-list-line',
        link: 'javascript:void(0)',
        name: 'piecework',
        roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_PIECEWORK],
        subItems: [
            {
                id: i++,
                label: 'Individual',
                link: '/daily-controls',
                name: 'daily-controls',
                parent: 'piecework',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_PIECEWORK]
            },
            {
                id: i++,
                label: 'Grupal',
                link: '/piecework',
                name: 'piecework',
                parent: 'piecework',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_PIECEWORK]
            }
        ]
    },
    {
        id: i++,
        label: 'Otros Controles',
        icon: 'ri-file-list-line',
        link: 'javascript:void(0)',
        name: 'other-controls',
        roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN],
        subItems: [
            {
                id: i++,
                label: 'Control de Refrigerio',
                link: '/lunch-controls',
                name: 'lunch-controls',
                parent: 'other-controls'
            },
            {
                id: i++,
                label: 'Control de Permisos',
                link: '/permission-controls',
                name: 'permission-controls',
                parent: 'other-controls'
            },
            {
                id: i++,
                label: 'Control de Préstamo',
                link: '/loan-controls',
                name: 'loan-controls',
                parent: 'other-controls'
            },
            {
                id: i++,
                label: 'Control de Adelantos',
                link: '/advance-control',
                name: 'advance-control',
                parent: 'other-controls'
            },
            {
                id: i++,
                label: 'Control de Bonos',
                link: '#',
                name: 'bond-control-menu',
                parent: 'other-controls',
                subItems: [
                    {
                        id: i++,
                        label: 'Carga Individual',
                        link: '/bond-control',
                        name: 'bond-control',
                        parent: 'bond-control-menu'
                    },
                    {
                        id: i++,
                        label: 'Carga Masiva',
                        link: '/bond-control-massive',
                        name: 'bond-control-massive',
                        parent: 'bond-control-menu'
                    }
                ]
            },
            {
                id: i++,
                label: 'Control de Descuentos',
                link: '/discount-control',
                name: 'discount-control',
                parent: 'other-controls'
            },
         /* {
                id: i++,
                label: 'Control de Liquidaciones',
                link: '/liquidacion-control',
                name: 'liquidacion-control',
                parent: 'other-controls'
            }, */
            {
                id: i++,
                label: 'Control de Bonos 4ta Cat.',
                link: '/cuarta-categoria',
                name: 'cuarta-categoria',
                parent: 'other-controls'
            }
        ]
    },
    {
        id: i++,
        label: 'Tareo',
        icon: 'ri-profile-line',
        link: '/task-sheets',
        name: 'task-sheets',
        roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN]
    },
    {
        id: i++,
        label: 'Planilla',
        icon: 'ri-profile-line',
        link: 'javascript:void(0)',
        name: 'payroll',
        roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN],
        subItems: [
            {
                id: i++,
                label: 'P. Quincenal',
                link: '/work-sheets',
                name: 'work-sheets',
                parent: 'payroll'
            },
            {
                id: i++,
                label: 'P. Consolidado Mensual',
                link: '/work-sheets-monthly',
                name: 'work-sheets-monthly',
                parent: 'payroll'
            }
        ]
    },
    {
        id: i++,
        label: 'Reportes',
        icon: 'ri-file-line',
        link: 'javascript:void(0)',
        name: 'reports',
        roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE],
        subItems: [
            {
                id: i++,
                label: 'Asistencia',
                link: '/report-asistance',
                name: 'report-asistance',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE]
            },
            {
                id: i++,
                label: 'Reporte AFP',
                link: '/report-afp',
                name: 'report-afp',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN]
            },
            {
                id: i++,
                label: 'Reporte Plame',
                link: '/report-plame',
                name: 'report-plame',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN]
            },
            {
                id: i++,
                label: 'Reporte Asistencia Interna',
                link: '/report-internal-assistance',
                name: 'report-internal-assistance',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE]
            },
            {
                id: i++,
                label: 'Boletas de pago',
                link: '/payment-slips',
                name: 'payment-slips',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE, ROLES_USER.USER_PIECEWORK]
            },
            {
                id: i++,
                label: 'Reporte Telecrédito',
                link: '/telecreditos',
                name: 'telecreditos',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE, ROLES_USER.USER_PIECEWORK]
            },
            {
                id: i++,
                label: 'Reporte Faltas',
                link: '/faltas',
                name: 'faltas',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE, ROLES_USER.USER_PIECEWORK]
            },
            {
                id: i++,
                label: 'Reporte Histórico',
                link: '/historico',
                name: 'historico',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE, ROLES_USER.USER_PIECEWORK]
            },
            {
                id: i++,
                label: 'Reporte de CTS',
                link: '/cts',
                name: 'cts',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE, ROLES_USER.USER_PIECEWORK]
            },
            {
                id: i++,
                label: 'Reporte de Gratificación',
                link: '/gratificacion',
                name: 'gratificacion',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE, ROLES_USER.USER_PIECEWORK]
            },
            {
                id: i++,
                label: 'Reporte de LBS',
                link: '/lbs',
                name: 'lbs',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE, ROLES_USER.USER_PIECEWORK]
            },
            {
                id: i++,
                label: 'Reporte de Utilidades',
                link: '/utilidades',
                name: 'utilidades',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE, ROLES_USER.USER_PIECEWORK]
            },
            {
                id: i++,
                label: 'Reporte Renta de 5ta',
                link: '/renta',
                name: 'renta',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE, ROLES_USER.USER_PIECEWORK]
            },
            {
                id: i++,
                label: 'Reporte Contabilidad',
                link: '/contabilidad',
                name: 'contabilidad',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE, ROLES_USER.USER_PIECEWORK]
            },
            {
                id: i++,
                label: 'Boletas Mensuales',
                link: '/boletas',
                name: 'boletas',
                parent: 'reports',
                roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN, ROLES_USER.USER_ASSISTANCE, ROLES_USER.USER_PIECEWORK]
            }
        ]
    },
    {
        id: i++,
        label: 'Configuraciones',
        icon: 'ri-tools-fill',
        link: 'javascript:void(0)',
        name: 'config',
        roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN],
        subItems: [
            {
                id: i++,
                label: 'Maestro de Empleados',
                link: '/employees',
                name: 'employees',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Tarifas de Refrigerio',
                link: '/rates-lunch',
                name: 'ratesLunch',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Descripción de Trabajo',
                link: '/work-description',
                name: 'work-description',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Áreas',
                link: '/areas',
                name: 'areas',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Sub Áreas',
                link: '/sub-areas',
                name: 'subAreas',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Cargos',
                link: '/positions',
                name: 'positions',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Compañía de Seguros',
                link: '/insurance-companies',
                name: 'insurance-companies',
                parent: 'config'
            },
            {
                id: i++,
                label: 'ESSALUD',
                link: '/other-config/1',
                name: 'otherConfig-1',
                parent: 'config'
            },
            {
                id: i++,
                label: 'ONP',
                link: '/other-config/2',
                name: 'otherConfig-1',
                parent: 'config'
            },
            {
                id: i++,
                label: 'SCTR',
                link: '/other-config/3',
                name: 'otherConfig-3',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Factor Dominical',
                link: '/other-config/4',
                name: 'otherConfig-4',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Tope Salarial - Destajo Grupal',
                link: '/other-config/5',
                name: 'otherConfig-5',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Centros de Costos',
                link: '/cost-center',
                name: 'cost_center',
                parent: 'config'
            },
            {
                id: i++,
                label: 'AFP',
                link: '/afp',
                name: 'afps',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Turnos de Trabajo',
                link: '/work-shifts',
                name: 'workShifts',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Semanas',
                link: 'javascript:void(0)',
                name: 'weeks',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Motivos de permisos',
                link: '/reason-for-permission',
                name: 'reasonForPermission',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Motivos de Cese Trabajo',
                link: '/reason-for-terminarion-work',
                name: 'reason-for-terminarion-work',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Tipos de Adelantos',
                link: '/advance-types',
                name: 'advanceTypes',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Tipos de Descuento',
                link: '/discount-types',
                name: 'discount-types',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Tipos de Bonos',
                link: '/bond-types',
                name: 'bond-types',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Días Festivos',
                link: '/holiday',
                name: 'holiday',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Usuarios',
                link: '/users',
                name: 'users',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Pesada Media Valva',
                link: '/heavy',
                name: 'heavy',
                parent: 'config'
            },
            {
                id: i++,
                label: 'Firmas',
                link: '/signatures',
                name: 'signatures',
                parent: 'config'
            }
        ]
    },
    {
        id: i++,
        label: 'Dispositivos',
        icon: 'ri-tv-2-fill',
        link: '/devices',
        name: 'devices',
        roleUser: [ROLES_USER.ADMIN, ROLES_USER.SUPER_ADMIN]
    }
]
